module.exports = __webpack_public_path__ + "img/jf-popup-bg.045ef8af.png";